module.exports = __webpack_public_path__ + "static/media/profile-holder.ca1aa447.png";